import { mulberry32 } from '../../../utils/seededRandomGenerator';

export const interseccion = (arr1, arr2) => {
  const set2 = new Set(arr2);
  const uniqueArr1 = Array.from(new Set(arr1)); // Ensure arr1 has unique values
  return uniqueArr1.filter(item => set2.has(item));
};

export const shuffleArray = (array, seed) => {
  const shuffledArray = [...array];
  const random = typeof seed === 'number' ? mulberry32(seed) : Math.random;
  for (let i = shuffledArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

export const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

export default {
  interseccion
};
